import ReportsPage from "../../admin/Reports/Index";

export default ReportsPage;
